import {Col} from 'react-bootstrap'
import deleteButton from '../../../../_metronic/images/deleteButton.svg'
import {alert} from '../../../../utils/helper'
import {IUtility} from './InterfaceProductSetup'
import {Key, ReactChild, ReactFragment, ReactPortal, useEffect, useState} from 'react'
import {ZipCodeModal} from './ZipCodeModal'
import Dropdown from '../../../sharedComponent/Dropdown/Dropdown'
import {State} from 'country-state-city'

interface utilityProps {
  id: string
  value: string
  utilityName: string
  utilityDunsNumber: string
  utilitySubmitDays: string
  utilityShortName: string
  utilityPhoneNumber: string
  setUtilityData: any
  regexValidation: string
  regexValidationMessage: string
  utilityState: string
  uanValidation: any
  errors: any
  readonly: boolean
  setDeletedId: any
  deletedId: any
  utilities: Array<any>
  setErrors: any
  zipcodes: string
  original: any
  meterRegexValidation: any
  meterRegexValidationMessage: any
  featureFlags: any
}

export default function Utility({
  id,
  value,
  utilityName,
  utilityDunsNumber,
  utilitySubmitDays,
  setUtilityData,
  utilityShortName,
  utilityPhoneNumber,
  uanValidation,
  regexValidation,
  regexValidationMessage,
  meterRegexValidation,
  meterRegexValidationMessage,
  utilityState,
  zipcodes,
  errors,
  readonly,
  setDeletedId,
  deletedId,
  utilities,
  setErrors,
  featureFlags,
}: utilityProps) {
  const handleValueChange = (property: any, changedValue: any) => {
    setUtilityData((prev: Array<IUtility>) =>
      prev.map((utility: any) => {
        if (utility.id === id) {
          utility[property] = changedValue
          return utility
        }
        return utility
      })
    )
    setErrors({})
  }
  const validateUtility = (changedValue: any) => {
    if (readonly === undefined && utilities?.includes(changedValue.toLowerCase())) {
      setUtilityData((prev: any) =>
        prev.map((utility: any) => {
          if (utility.id === id) {
            utility['value'] = ''
            return utility
          }
          return utility
        })
      )
      alert('Utility Already Exists', 'warning')
    }
  }
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [state, setState] = useState<{id: string; value: string}[]>([])

  useEffect(() => {
    const getAllStates = State.getStatesOfCountry('US')
    setState(getAllStates.map((eachState) => ({id: eachState.isoCode, value: eachState.name})))
  }, [])

  const handleCloseModal = () => {
    const modalElement = document.getElementById('kt_modal_1')
    if (modalElement) {
      modalElement.style.display = 'block'
    }
    setShowCreateAppModal(false)
  }
  const openModal = (e: any) => {
    const modalElement = document.getElementById('kt_modal_1')
    if (modalElement) {
      modalElement.style.display = 'none'
    }
    e.stopPropagation()
    e.preventDefault()
    setShowCreateAppModal(true)
  }
  return (
    <div className='g-5 mb-7 align-items-center py-7 px-5 custom-box-shadow mt-3 position-relative'>
      <div className='d-flex gap-5 overflow-auto utilityBlock'>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold required'>Utility</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            value={value === undefined ? '' : value}
            placeholder='Enter utility'
            readOnly={readonly}
            onChange={(e) => {
              handleValueChange('value', e.target.value)
            }}
            onBlur={() => validateUtility(value)}
          />
          {errors[id]?.utility && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Utility is required
              </div>
            </div>
          )}
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold required'>
            Utility Pronunciation
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() => alert('Pronunciation for Utility name in scripts', 'info')}
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            value={Boolean(utilityShortName) ? utilityShortName : ''}
            placeholder='Enter pronunciation'
            onChange={(e) => {
              handleValueChange('utilityShortName', e.target.value)
            }}
            onBlur={() => validateUtility(value)}
          />
          {errors[id]?.shortName && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Pronunciation is required
              </div>
            </div>
          )}
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold'>
            Utility Name
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() =>
                alert(
                  'Displays full Utility Name during enrollment. Otherwise, name in Utility will be displayed',
                  'info'
                )
              }
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            value={Boolean(utilityName) ? utilityName : ''}
            placeholder='Enter utility name'
            onChange={(e) => {
              handleValueChange('utilityName', e.target.value)
            }}
            onBlur={() => validateUtility(value)}
          />
          {errors[id]?.utilityName && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Utility Name is required
              </div>
            </div>
          )}
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='mb-2 fw-semibold required'>Utility DUNS Number</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter DUNS number'
            value={utilityDunsNumber}
            onChange={(e) => handleValueChange('utilityDunsNumber', e.target.value)}
          />
          {errors[id]?.dunsNumber && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Utility DUNS number is required
              </div>
            </div>
          )}
        </Col>
        <Col lg={2} className='mb-2  mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            Submit Days
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() => alert('Submit Date would be TPV Date + Days added', 'info')}
            ></i>
          </label>
          <input
            type='string'
            className='form-control form-control-lg form-control-solid'
            value={utilitySubmitDays}
            min={1}
            step={1}
            placeholder='Enter Days'
            onChange={(e) => {
              handleValueChange(
                'utilitySubmitDays',
                e.target.value.replace('.', '').replace('+', '').replace('-', '')
              )
            }}
          />
        </Col>
        <Col lg={2} className='mb-2  mt-0 pb-6'>
          <label className='mb-2 fw-semibold'>Utility Phone Number</label>
          <div className='d-flex p-relative'>
            <div className='d-flex p-relative'>
              <input
                type='text'
                value='+1'
                className='form-control form-control-lg form-control-solid d-inline'
                disabled
                style={{
                  width: '25px',
                  padding: '0px',
                  borderTopRightRadius: '0px',
                  borderBottomRightRadius: '0px',
                  fontSize: '14px',
                }}
              />
              <input
                type='number'
                maxLength={10}
                className='form-control form-control-lg form-control-solid p-3 d-inline'
                name='utilityPhoneNumber'
                placeholder='Enter phone number'
                value={Boolean(utilityPhoneNumber) ? utilityPhoneNumber : ''}
                pattern='[0-9]*'
                onChange={(e) =>
                  e.target.value.length < 11 &&
                  handleValueChange('utilityPhoneNumber', e.target.value)
                }
              />
            </div>
          </div>
          {errors[id]?.invalidPhoneNumber && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Invalid Phone number
              </div>
            </div>
          )}
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            UAN Validation
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() =>
                alert('Helps ensure Utility Account Number has specified number of digits', 'info')
              }
            ></i>
          </label>
          <input
            type='string'
            className='form-control form-control-lg form-control-solid d-inline'
            name='utilityPhoneNumber'
            placeholder='Enter UAN digits'
            value={Boolean(uanValidation) ? uanValidation : ''}
            onChange={(e) => {
              handleValueChange('uanValidation', e.target.value.replace(/[+\-]/g, ''))
            }}
          />
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            UAN Regex
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() =>
                alert('Helps ensure Utility Account Number has specified pattern', 'info')
              }
            ></i>
          </label>
          <input
            type='string'
            className='form-control form-control-lg form-control-solid d-inline'
            name='utilityregex'
            placeholder='Enter Regex'
            value={regexValidation}
            onChange={(e) => {
              handleValueChange('regexValidation', e.target.value)
            }}
          />
        </Col>
        <Col lg={2} className='mb-2 mt-0 pb-6'>
          <label className='fw-semibold mb-2'>
            UAN Regex Message
            <i
              className='bi bi-info-circle ms-2 text-primary cursor-pointer'
              onClick={() => alert('Display Utility number format for enrollment', 'info')}
            ></i>
          </label>
          <input
            type='string'
            className='form-control form-control-lg form-control-solid d-inline'
            name='utilityRegexMessage'
            placeholder='Enter Regex message'
            value={regexValidationMessage}
            onChange={(e) => {
              handleValueChange('regexValidationMessage', e.target.value)
            }}
          />
        </Col>
        {featureFlags?.getClientFeatureFlags?.isUtilityMeterNumberRequired && (
          <>
            {' '}
            <Col lg={2} className='mb-2 mt-0 pb-6'>
              <label className='fw-semibold mb-2'>
                Meter ID Regex
                <i
                  className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                  onClick={() => alert('Helps ensure Meter Id has specified pattern', 'info')}
                ></i>
              </label>
              <input
                type='string'
                className='form-control form-control-lg form-control-solid d-inline'
                name='meterregex'
                placeholder='Enter Meter ID'
                value={meterRegexValidation}
                onChange={(e) => {
                  handleValueChange('meterRegexValidation', e.target.value)
                }}
              />
            </Col>
            <Col lg={3} className='mb-2 mt-0 pb-6'>
              <label className='fw-semibold mb-2'>
                Meter ID Regex Message
                <i
                  className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                  onClick={() => alert('Display Meter ID for enrollment', 'info')}
                ></i>
              </label>
              <input
                type='string'
                className='form-control form-control-lg form-control-solid d-inline'
                name='meterRegexMessage'
                placeholder='Enter Meter ID message'
                value={meterRegexValidationMessage}
                onChange={(e) => {
                  handleValueChange('meterRegexValidationMessage', e.target.value)
                }}
              />
            </Col>
          </>
        )}
        {featureFlags?.getClientFeatureFlags?.enableZipCodeInUtility && (
          <Col lg={2} className='mb-2 mt-0 pb-6'>
            <label className='fw-semibold mb-2'>State</label>
            <select
              id='utilityState'
              name='utilityState'
              value={utilityState}
              className='basic-single form-select form-select-solid'
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                handleValueChange('utilityState', e.target.value)
              }
            >
              <option value=''>Select a State</option>
              {Array.isArray(state) &&
                state.map((option: {id: string; value: string}) => (
                  <option key={option.id} value={option.value}>
                    {option.value}
                  </option>
                ))}
            </select>
          </Col>
        )}

        {featureFlags?.getClientFeatureFlags?.enableZipCodeInUtility && (
          <Col lg={2} className='mb-2 mt-0 pb-6'>
            <label className='fw-semibold mb-2'>
              Zip Code
              <i
                className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                onClick={() =>
                  alert('Helps ensure the area where the utility is available', 'info')
                }
              ></i>
            </label>
            <div className='d-flex flex-stack '>
              <button className='btn btn-light-primary' onClick={openModal}>
                View All
              </button>
            </div>
            <ZipCodeModal
              show={showCreateAppModal}
              handleClose={handleCloseModal}
              zipcodes={zipcodes ? zipcodes : []}
              handleValueChange={handleValueChange}
            />
          </Col>
        )}
      </div>
      <button
        className='btn btn-icon align-self-end ms-4'
        disabled={readonly}
        onClick={(e) => {
          setUtilityData((prev: any) => prev.filter((utility: any) => utility.id !== id))
          if (readonly !== undefined) {
            setDeletedId([...deletedId, id])
          }
        }}
        style={{
          position: 'absolute',
          right: '0',
          top: '-17px',
        }}
      >
        <img src={deleteButton} alt='delete' />
      </button>
    </div>
  )
}
